import { MDText } from 'i18n-react';

import { ACCOUNT_SETTINGS_COMPANY_INFORMATION_LINK } from 'Components/pages/AccountSettings/AccountSettings.consts';

import { TextCTA } from '../../TextCTA/TextCTA';
import biddingSectionCTAStateControllerTexts from '../BiddingSectionCTAStateController.texts';

const kycLocalT = new MDText(biddingSectionCTAStateControllerTexts.placeBidKycBeforeSubmit);

export const PlaceBidKycBeforeSubmit: React.FC = () => (
	<TextCTA
		buttonProps={{
			href: ACCOUNT_SETTINGS_COMPANY_INFORMATION_LINK,
			text: `${kycLocalT.translate('buttonText')}`,
		}}
		description={`${kycLocalT.translate('description')}`}
		title={`${kycLocalT.translate('title')}`}
	/>
);
